<script setup lang="ts">
import ThinFrame from "@/components/Common/ThinFrame.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'ScreenshotCarousel',

    data() {
        return {
        }
    },
})
</script>

<template>
    <div class="carouselBox">
        <ThinFrame :offset="7"/>

        <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel" data-bs-interval="4000">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img :src="`/img/page/landing/screenshot/1.jpg`" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item">
                    <img :src="`/img/page/landing/screenshot/3.jpg`" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item">
                    <img :src="`/img/page/landing/screenshot/4.jpg`" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item">
                    <img :src="`/img/page/landing/screenshot/2.jpg`" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item">
                    <img :src="`/img/page/landing/screenshot/5.jpg`" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item">
                    <img :src="`/img/page/landing/screenshot/6.jpg`" class="d-block w-100" alt="...">
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>
</template>

<style scoped lang="scss">
.carouselBox {
    position: relative;
    width: 100%;
    box-shadow: 0 0 15px 7px black;
    border-radius: 20px;
}

.carousel {
    overflow: hidden;
    border-radius: 25px;
}
</style>
